import BasicTable from 'Components/UI/Atoms/BasicTable'

const Comprobantes = ({ data }) => {
  return (
    <>
      <div style={{ display: 'flex', margin: '2rem' }}>
        <BasicTable
          col={[
            { title: 'Fecha', style: { width: '100px' } },
            { title: 'Tipo comprobante', style: { width: '100px' } },
            { title: 'Nº comprobante', style: { width: '100px' } },
            { title: 'CAE', style: { width: '100px' } },
            { title: 'Importe', style: { width: '60px' } },
          ]}
          size="small"
          rows={data.comprobantes.map((row) => {
            return {
              fecha: row.fecha,
              tipo_comprobante: row.tipo_comprobante,
              nro_comprobante: row.nro_comprobante,
              cae: row.cae,
              imptotal: `$ ${row.imptotal}`,
            }
          })}
        />
      </div>
    </>
  )
}

export default Comprobantes
